import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
import { diagnosisProtocols } from "../../../../config/validateProtocols";
// Components
import { Header, TitleBox, HeaderTitle } from "./styles";
import Loader from "../../../loader";
import Axios from "../../../../config/axios";
import Title from "../../../title";
import RenderProtocols from "./sections/renderProtocols";

const ProtocolReports = () => {
  const [isLoadingSessionsNumber, setIsLoadingSessionsNumber] = useState(true);
  const [protocolsSessionsNumber, setProtocolsSessionsNumber] = useState([]);

  const { patientId, software } = useParams();
  const [t] = useTranslation("global");

  // Fetching number of sessions by protocol
  useEffect(() => {
    Axios("get", `${WEB_SERVICE_MIMS}/sessions/get/${patientId}/${software}`)
      .then(({ data }) => {
        setProtocolsSessionsNumber(data);
        setIsLoadingSessionsNumber(false);
      })
      .catch((error) => {
        console.log("Get number of sessions by protocol: ", error);
      });
  }, [patientId, software]);

  const renderProtocolsHeader = () => {
    return (
      <Header>
        <TitleBox width="88%">
          <HeaderTitle>{t("diagnosisProtocols_diagnosisActivities").toUpperCase()}</HeaderTitle>
        </TitleBox>
        <TitleBox width="12%">
          <HeaderTitle>{t("reports").toUpperCase()}</HeaderTitle>
        </TitleBox>
      </Header>
    );
  };

  const renderProtocols = () => {
    return diagnosisProtocols.map((diagnosisProtocol) => {
      const protocolId = diagnosisProtocol.id;
      const protocolSessions = protocolsSessionsNumber.filter((protocol) => protocol.PROTOCOL_ID === protocolId)[0];
      const protocolSessionsNumber = protocolSessions ? protocolSessions.sessionsNumber : 0;
      return <RenderProtocols key={protocolId} protocolId={protocolId} sessionsNumber={protocolSessionsNumber} />;
    });
  };

  return (
    <>
      {isLoadingSessionsNumber ? (
        <Loader />
      ) : (
        <>
          <Title title={t("diagnosisProtocols_diagnosisActivities").toUpperCase()} marginBottom="10px" />
          {renderProtocolsHeader()}
          {renderProtocols()}
        </>
      )}
    </>
  );
};

export default ProtocolReports;
